import Vue from 'vue'
import router from './router'
import store from './store'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css' // Progress 进度条样式
import { Message } from 'element-ui'
import Storage from '@/utils/storage'

const whiteList = ['/login']

router.beforeEach((to, from, next) => {
  
  NProgress.start()
  const token = Storage.getItem('jession_token')
  let roleName = [] // check接口返回的权限名称
  if (token) {
    if (to.path === '/login') {
      next({ path: '/' })
      NProgress.done()
    } else {
      
      if (store.getters.addRouters.length === 0) {
        store.dispatch('GenerateRoutes').then(() => {
          router.addRoutes(store.getters.addRouters)
          // Storage.setItem('roleName', store.getters.roleName)
          next({ ...to, replace: true })
        }).catch(() => {
          store.dispatch('fedLogoutAction').then(() => {
            Message.error('验证失败,请重新登录')
            window.location.replace(`/login?forward=${location.pathname}&${location.search.substr(1)}`)
          })
        })
      } else {
        next()
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()// 非白名单需  token ，无token去登陆
    } else {
      next(`/login?forward=${location.pathname}&${location.search.substr(1)}`)
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done()
})



// WEBPACK FOOTER //
// ./src/permission.js